"use strict";
import { Component, Input } from "@angular/core";
var CompleterListItemCmp = (function () {
    function CompleterListItemCmp() {
        this.parts = [];
    }
    CompleterListItemCmp.prototype.ngOnInit = function () {
        if (!this.searchStr) {
            this.parts.push({ isMatch: false, text: this.text });
            return;
        }
        var matchStr = this.text.toLowerCase();
        var matchPos = matchStr.indexOf(this.searchStr.toLowerCase());
        var startIndex = 0;
        while (matchPos >= 0) {
            var matchText = this.text.slice(matchPos, matchPos + this.searchStr.length);
            if (matchPos === 0) {
                this.parts.push({ isMatch: true, text: matchText });
                startIndex += this.searchStr.length;
            }
            else if (matchPos > 0) {
                var matchPart = this.text.slice(startIndex, matchPos);
                this.parts.push({ isMatch: false, text: matchPart });
                this.parts.push({ isMatch: true, text: matchText });
                startIndex += this.searchStr.length + matchPart.length;
            }
            matchPos = matchStr.indexOf(this.searchStr.toLowerCase(), startIndex);
        }
        if (startIndex < this.text.length) {
            this.parts.push({ isMatch: false, text: this.text.slice(startIndex, this.text.length) });
        }
    };
    return CompleterListItemCmp;
}());
export { CompleterListItemCmp };
CompleterListItemCmp.decorators = [
    { type: Component, args: [{
                selector: "completer-list-item",
                template: "\n    <span class=\"completer-list-item-holder\" [ngClass]=\"{'completer-title': type === 'title', 'completer-description': type === 'description'}\" >\n        <span class=\"completer-list-item\" *ngFor=\"let part of parts\" [ngClass]=\"part.isMatch ? matchClass : null\">{{part.text}}</span>\n    </span>\n    "
            },] },
];
/** @nocollapse */
CompleterListItemCmp.ctorParameters = function () { return []; };
CompleterListItemCmp.propDecorators = {
    'text': [{ type: Input },],
    'searchStr': [{ type: Input },],
    'matchClass': [{ type: Input },],
    'type': [{ type: Input },],
};
//# sourceMappingURL=completer-list-item-cmp.js.map


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/ng2-completer/components/completer-list-item-cmp.js
// module id = ../../../../ng2-completer/components/completer-list-item-cmp.js
// module chunks = 37